/**
 * A phone number as `tel:` and WhatsApp links. Numbers are typed however the
 * owner likes; WhatsApp wants digits only with the country code, so a local
 * Tunisian number (8 digits) gets 216 in front, "00…" and "+…" are trimmed.
 */
export const digitsOf = (phone) => {
  let digits = String(phone || "").replace(/[^\d+]/g, "");
  if (digits.startsWith("+")) return digits.slice(1).replace(/\D/g, "");
  digits = digits.replace(/\D/g, "");
  if (digits.startsWith("00")) return digits.slice(2);
  if (digits.length === 8) return `216${digits}`;
  return digits;
};

export const telLink = (phone) => `tel:+${digitsOf(phone)}`;

export const whatsappLink = (phone, text = "") =>
  `https://wa.me/${digitsOf(phone)}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
